import { render, staticRenderFns } from "./RouteReportSimple.vue?vue&type=template&id=881f80e8&scoped=true&"
import script from "./RouteReportSimple.vue?vue&type=script&lang=js&"
export * from "./RouteReportSimple.vue?vue&type=script&lang=js&"
import style0 from "./RouteReportSimple.vue?vue&type=style&index=0&id=881f80e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881f80e8",
  null
  
)

export default component.exports